module.exports = __webpack_public_path__ + "static/media/IOTSU_L4_AQ08.b4d5ad92.jpg";